import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, Fragment as _Fragment } from "vue"
import _imports_0 from '@/assets/common/icon_back.png'
import _imports_1 from '@/assets/themetwo/back.png'
import _imports_2 from '@/assets/common/backIcon.png'


const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = { key: 2 }
const _hoisted_4 = { key: 3 }
const _hoisted_5 = { style: {"padding":"0px 20px"} }

import { useThemeStore } from '@/stores/theme'
import GameHeaderBarOne from '@/themes/themeOne/game/components/gameHeaderBar.vue'
import GameHeaderBarTwo from '@/themes/themeTwo/game/components/gameHeaderBar.vue'
import GameHeaderBarThree from '@/themes/themeThree/game/components/gameHeaderBar.vue'
import GameHeaderBarFour from '@/themes/themeFour/game/components/gameHeaderBar.vue'
import DepositView from '@/view/deposit/depositView.vue'
import { getNewsBarText } from '../supportScript'
import { ref } from 'vue'

export default /*@__PURE__*/_defineComponent({
  __name: 'gameHeadBar',
  props: {
    isFavorite: { type: Boolean }
  },
  emits: ['backClick', 'addFavorite'],
  setup(__props: any, { emit: __emit }) {

const props = __props
const themeStore = useThemeStore()
const noticeText = ref(getNewsBarText())
const show = ref(false)
const emits = __emit
const handleBackClick = () => {
    emits('backClick')
}

const showDepositPopup = () => {
    show.value = true
    localStorage.setItem('showDepositBackIcon','1')
}

const closePopup = () => {
    show.value = false
    localStorage.setItem('showDepositBackIcon','0')
}

const addFavorite = () => {
    emits('addFavorite')
}

return (_ctx: any,_cache: any) => {
  const _component_van_col = _resolveComponent("van-col")!
  const _component_van_row = _resolveComponent("van-row")!
  const _component_van_popup = _resolveComponent("van-popup")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_unref(themeStore).themeIndex === 1)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(GameHeaderBarOne, {
            onBackClick: handleBackClick,
            onShowDepositPopup: showDepositPopup,
            "notice-text": noticeText.value,
            "is-favorite": _ctx.isFavorite,
            onAddFavorite: addFavorite
          }, null, 8, ["notice-text", "is-favorite"])
        ]))
      : _createCommentVNode("", true),
    (_unref(themeStore).themeIndex === 2)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(GameHeaderBarTwo, {
            onBackClick: handleBackClick,
            onShowDepositPopup: showDepositPopup,
            "notice-text": noticeText.value,
            "is-favorite": _ctx.isFavorite,
            onAddFavorite: addFavorite
          }, null, 8, ["notice-text", "is-favorite"])
        ]))
      : _createCommentVNode("", true),
    (_unref(themeStore).themeIndex === 3)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createVNode(GameHeaderBarThree, {
            onBackClick: handleBackClick,
            onShowDepositPopup: showDepositPopup,
            "notice-text": noticeText.value,
            "is-favorite": _ctx.isFavorite,
            onAddFavorite: addFavorite
          }, null, 8, ["notice-text", "is-favorite"])
        ]))
      : _createCommentVNode("", true),
    (_unref(themeStore).themeIndex === 4)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createVNode(GameHeaderBarFour, {
            onBackClick: handleBackClick,
            onShowDepositPopup: showDepositPopup,
            "notice-text": noticeText.value,
            "is-favorite": _ctx.isFavorite,
            onAddFavorite: addFavorite
          }, null, 8, ["notice-text", "is-favorite"])
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_van_popup, {
      show: show.value,
      "onUpdate:show": _cache[0] || (_cache[0] = ($event: any) => ((show).value = $event)),
      position: "right",
      style: _normalizeStyle({
        width: '100%',
        height: '100%',
        color: '#fff',
        overflow: 'hidden',
        background: _unref(themeStore).themeIndex == 1 ? '#1e130b' : _unref(themeStore).themeIndex == 2 ? '#221b24' : '#101423',
    })
    }, {
      default: _withCtx(() => [
        _createVNode(_component_van_row, {
          style: _normalizeStyle({ background: _unref(themeStore).themeIndex == 1 ? '#27190D' :_unref(themeStore).themeIndex == 2 ? '#312734':'#154084' })
        }, {
          default: _withCtx(() => [
            _createVNode(_component_van_col, { span: "2" }, {
              default: _withCtx(() => [
                (_unref(themeStore).themeIndex === 1)
                  ? (_openBlock(), _createElementBlock("img", {
                      key: 0,
                      width: "100%",
                      src: _imports_0,
                      alt: "",
                      onClick: closePopup
                    }))
                  : _createCommentVNode("", true),
                (_unref(themeStore).themeIndex === 2)
                  ? (_openBlock(), _createElementBlock("img", {
                      key: 1,
                      width: "100%",
                      src: _imports_1,
                      alt: "",
                      onClick: closePopup
                    }))
                  : _createCommentVNode("", true),
                (_unref(themeStore).themeIndex === 3)
                  ? (_openBlock(), _createElementBlock("img", {
                      key: 2,
                      width: "50%",
                      style: {"padding":"15px"},
                      src: _imports_2,
                      alt: "",
                      onClick: closePopup
                    }))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }),
            _createVNode(_component_van_col, {
              span: "20",
              style: {"display":"flex","justify-content":"center","align-items":"center","text-align":"center","font-size":"15px"}
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('common.deposite')), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["style"]),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(DepositView, { "is-component": true })
        ])
      ]),
      _: 1
    }, 8, ["show", "style"])
  ], 64))
}
}

})